import Api from "@/services/Api";

export default {
  validate(credentials) {
    return Api().post("validate.php", credentials);
  },
  provision(credentials) {
    return Api().post("provision.php", credentials);
  }
};
